import { typeIdObj } from '@home/utils/buriedPoint';

export const MOBILE_COMPETITOR_TABLE_DOWNLOAD = {
  pageId: '902601',
  // 01 和 02为后面筛选器确认与重置添加打点预留
  buttonId: '90260103',
  extInfo: 'table download',
  typeId: typeIdObj.studio,
};